import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { SVGProps } from "react";
export interface Iphone15ProProps extends SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  src?: string;
}
export function Iphone15Pro(t0) {
  const $ = _c(26);
  let props;
  let src;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      width: t1,
      height: t2,
      src,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = src;
    $[3] = t1;
    $[4] = t2;
  } else {
    props = $[1];
    src = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const width = t1 === undefined ? 433 : t1;
  const height = t2 === undefined ? 882 : t2;
  const t3 = `0 0 ${width} ${height}`;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <clipPath id="screenClip"><path d="M21.25 75C21.25 44.2101 46.2101 19.25 77 19.25H355C385.79 19.25 410.75 44.2101 410.75 75V807C410.75 837.79 385.79 862.75 355 862.75H77C46.2101 862.75 21.25 837.79 21.25 807V75Z" /></clipPath>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <defs>{t4}<clipPath id="roundedCorners"><rect x="21.25" y="19.25" width="389.5" height="843.5" rx="55.75" ry="55.75" /></clipPath></defs>;
    t6 = <path d="M2 73C2 32.6832 34.6832 0 75 0H357C397.317 0 430 32.6832 430 73V809C430 849.317 397.317 882 357 882H75C34.6832 882 2 849.317 2 809V73Z" className="fill-neutral-800" />;
    t7 = <path d="M0 171C0 170.448 0.447715 170 1 170H3V204H1C0.447715 204 0 203.552 0 203V171Z" className="fill-neutral-700" />;
    t8 = <path d="M1 234C1 233.448 1.44772 233 2 233H3.5V300H2C1.44772 300 1 299.552 1 299V234Z" className="fill-neutral-700" />;
    t9 = <path d="M1 319C1 318.448 1.44772 318 2 318H3.5V385H2C1.44772 385 1 384.552 1 384V319Z" className="fill-neutral-700" />;
    t10 = <path d="M430 279H432C432.552 279 433 279.448 433 280V384C433 384.552 432.552 385 432 385H430V279Z" className="fill-neutral-700" />;
    t11 = <path d="M6 74C6 35.3401 37.3401 4 76 4H356C394.66 4 426 35.3401 426 74V808C426 846.66 394.66 878 356 878H76C37.3401 878 6 846.66 6 808V74Z" className="fill-neutral-800" />;
    t12 = <path opacity="0.5" d="M174 5H258V5.5C258 6.60457 257.105 7.5 256 7.5H176C174.895 7.5 174 6.60457 174 5.5V5Z" className="fill-background dark:fill-neutral-700" />;
    t13 = <path d="M21.25 75C21.25 44.2101 46.2101 19.25 77 19.25H355C385.79 19.25 410.75 44.2101 410.75 75V807C410.75 837.79 385.79 862.75 355 862.75H77C46.2101 862.75 21.25 837.79 21.25 807V75Z" className="fill-muted stroke-neutral-800" />;
    $[6] = t10;
    $[7] = t11;
    $[8] = t12;
    $[9] = t13;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t10 = $[6];
    t11 = $[7];
    t12 = $[8];
    t13 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  let t14;
  if ($[15] !== src) {
    t14 = src && <foreignObject x="21.5" y="20" width="388" height="468" clipPath="url(#screenClip)"><Image src={src} alt="Thumbnail image of newsletter section device mockup" fill={true} sizes="600px" className="object-cover" /></foreignObject>;
    $[15] = src;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  let t16;
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <path d="M154 48.5C154 38.2827 162.283 30 172.5 30H259.5C269.717 30 278 38.2827 278 48.5C278 58.7173 269.717 67 259.5 67H172.5C162.283 67 154 58.7173 154 48.5Z" className="fill-neutral-800" />;
    t16 = <path d="M249 48.5C249 42.701 253.701 38 259.5 38C265.299 38 270 42.701 270 48.5C270 54.299 265.299 59 259.5 59C253.701 59 249 54.299 249 48.5Z" className="fill-neutral-700" />;
    t17 = <path d="M254 48.5C254 45.4624 256.462 43 259.5 43C262.538 43 265 45.4624 265 48.5C265 51.5376 262.538 54 259.5 54C256.462 54 254 51.5376 254 48.5Z" className="fill-neutral-600" />;
    $[17] = t15;
    $[18] = t16;
    $[19] = t17;
  } else {
    t15 = $[17];
    t16 = $[18];
    t17 = $[19];
  }
  let t18;
  if ($[20] !== height || $[21] !== props || $[22] !== t14 || $[23] !== t3 || $[24] !== width) {
    t18 = <svg width={width} height={height} viewBox={t3} fill="none" xmlns="http://www.w3.org/2000/svg" className="relative" {...props}>{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}</svg>;
    $[20] = height;
    $[21] = props;
    $[22] = t14;
    $[23] = t3;
    $[24] = width;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  return t18;
}